<template>
    <v-layout class="pa-3">
        <div class="points_icon wrapper-relative mr-4">
            <!-- <v-badge :style="content.type=='recieved'? 'background-color: #44b69e;':'background-color:#e2173d'"> -->
            <v-badge :style="content.type=='received'? 'color: #44b69e;':'color:#e2173d'">
                <span slot="badge"
                      class="points_badge"
                      :style="content.type=='received'? 'background-color: #44b69e;':'background-color:#e2173d'"
                >{{ content.points }}</span>
                <svg v-svg
                     :style="content.type=='received' ? 'color: #44b69e;':'color:#e2173d'"
                     :symbol="icons"
                     size="30 30"
                     role="presentation"
                />
            </v-badge>
        </div>
        <v-layout column>
            <v-layout wrap>
                <v-flex>
                    {{ $t(content.title) }}
                </v-flex>
                <v-layout justify-end>
                    <div>{{ day(content.date) }}</div><div class="grey-text ml-2">{{ time(content.date) }}</div>
                </v-layout>
            </v-layout>
            <div class="grey-text">
                {{ $t(content.text) }}
            </div>
        </v-layout>
    </v-layout>
</template>

<script>
import dayjs from 'dayjs';
export default {
  props: {
    content: {
      type: Object,
    },
    tab: {},
  },
  computed: {
    section_icon() {
      if (this.content.section == 'study') {
        return 'book';
      } else if (this.content.section == 'prizes') {
        return 'new_prize';
      } else if (this.content.section == 'ideas') {
        return 'idea_change';
      } else if (this.content.section == 'rating') {
        return 'rating_change';
      } else if (this.content.section == 'bonus') {
        return 'new_prize';
      }
    },
    icons() {
      if (this.content.type === 'spent') {
        return 'negative_price';
      } else {
        return this.section_icon;
      }
    },
  },
  methods: {
    day(date) {
      return new dayjs(date*1000).format('DD.MM.YY');
    },
    time(date) {
      return new dayjs(date*1000).format('HH:mm');
    },
  },
};
</script>

<style lang="sass" scoped>
span.v-badge
    margin-top: 5px
</style>
